import React from 'react';
import { CheckCircle, Award, Zap } from 'lucide-react';
import { motion } from 'framer-motion';

export default function AboutSection() {
  const features = [
    { icon: Award, text: 'Certified Professionals', color: 'bg-slate-900/10 text-slate-900' },
    { icon: Zap, text: 'Fast Response', color: 'bg-slate-900/10 text-slate-900' },
    { icon: CheckCircle, text: '100% Satisfaction', color: 'bg-slate-800/10 text-slate-800' }
  ];

  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Bento Grid */}
        <div className="grid lg:grid-cols-12 gap-6">
          {/* Main Card - Large */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.2 }}
            className="lg:col-span-7 bg-white rounded-3xl p-8 lg:p-12 shadow-sm hover:shadow-lg transition-all"
          >
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-slate-100 mb-6">
              <span className="text-sm text-slate-600 font-medium">About Us</span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-light text-slate-900 mb-6 leading-tight">
              Drainage Excellence
              <span className="block font-bold"></span>
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-8">
              Total Repair UK brings over 25 years of expertise in professional drainage solutions. 
              Our certified team delivers fast, reliable service with a commitment to quality that sets us apart.
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              {features.map((feature, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.05, duration: 0.2 }}
                  className="flex items-center gap-3"
                >
                  <div className={`w-10 h-10 rounded-2xl ${feature.color} flex items-center justify-center`}>
                    <feature.icon className="w-5 h-5" />
                  </div>
                  <span className="text-slate-700 font-medium">{feature.text}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

        </div>

        {/* Video Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.3, delay: 0.2 }}
          className="mt-16"
        >
          <div className="bg-white rounded-3xl shadow-sm overflow-hidden">
            <div className="relative aspect-video w-full">
              <video
                autoPlay
                loop
                muted
                playsInline
                className="w-full h-full object-cover"
              >
                <source src="/video.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              {/* Overlay gradient for better text readability */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent pointer-events-none" />
            </div>
            <div className="p-6 lg:p-8">
              <h3 className="text-2xl lg:text-3xl font-light text-slate-900 mb-4">
                Our Work in <span className="font-bold">Action</span>
              </h3>
              <p className="text-slate-600 leading-relaxed">
                See how our expert team handles complex drainage challenges with precision and professionalism. 
                From routine maintenance to emergency repairs, we deliver solutions that last.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}